module.exports = __webpack_public_path__ + "img/pennellata-san-dona-di-piave.580ddc6f.png";